export const ZALO_LINK = "https://zalo.me/0942733692"; // Thay yourprofile bằng ID Zalo của bạn 